<template>
  <div class="GlassCost">
    <ATable
      ref="table"
      :loading="loading"
      :placeholder="placeholder"
      :search_field="search_field"
      :data="filteredItem"
      :exportExcel="handleClickExportExcel"
      max-height="722px"
      highlight-current-row
      hide-button-insert
      border
      hide-pagination
      @cell-click="handleCellClick"
    >
      <div slot="search" class="inline">
        <div class="inline">
          <el-select
            size="mini"
            style="width:100px;"
            v-model="search_glass_thickness_name"
            placeholder="전체"
          >
            <el-option :key="0" :value="0" label="전체" />
            <el-option
              v-for="item in table_glass_thickness"
              :key="item.id"
              :label="item.name"
              :value="item.name"
            />
          </el-select>
        </div>
        <div class="inline text-warning ml-default">
          요율로 등록하려면 가격 좌측의 체크 박스를 선택하세요.
        </div>
      </div>
      <el-table-column
        type="index"
        label="No"
        :index="handleIndex"
        :width="$width.indexw"
      />
      <el-table-column
        prop="product_code"
        width="60"
        :label="$t('lang.code')"
      />
      <el-table-column
        prop="product_name"
        label="품목명"
        show-overflow-tooltip
      />
      <el-table-column prop="glass_color_name" label="색상" width="120" />
      <el-table-column prop="glass_thickness_name" label="두께" width="50" />
      <el-table-column
        width="90"
        class-name="cell-number"
        label="평당가"
        prop="price"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.id === editingId">
            <ANumberInput
              v-model="scope.row.price"
              :disabled="!has_grant_write"
            />
          </div>
          <div v-else>
            {{ util.addComma(scope.row.price) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        width="90"
        class-name="cell-number"
        v-for="level in table_customer_glass_level"
        :key="level.id"
        :label="level.code"
        :prop="'price_' + level.id"
      >
        <template slot-scope="scope">
          <div class="flex">
            <div class="price-ratio">
              <span v-if="scope.row.id === editingId">
                <ACheckboxYN
                  v-model="scope.row.custom[level.id].ratio_flag"
                  :disabled="!has_grant_write"
                />
              </span>
              <span v-else>
                <i
                  class="el-icon-check"
                  v-show="scope.row.custom[level.id].ratio_flag === 'Y'"
                />
              </span>
            </div>
            <div class="flex-auto">
              <div v-if="scope.row.id === editingId">
                <ANumberInput
                  v-model="scope.row.custom[level.id].price"
                  :disabled="!has_grant_write"
                />
              </div>
              <div v-else>
                {{ util.addComma(scope.row.custom[level.id].price) }}
              </div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        width="90"
        class-name="cell-number"
        label="면취비"
        prop="chamfer_price"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.id === editingId">
            <ANumberInput
              v-model="scope.row.chamfer_price"
              :disabled="!has_grant_write"
            />
          </div>
          <div v-else>
            {{ util.addComma(scope.row.chamfer_price) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        width="90"
        class-name="cell-number"
        label="따내기"
        prop="chip_price"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.id === editingId">
            <ANumberInput
              v-model="scope.row.chip_price"
              :disabled="!has_grant_write"
            />
          </div>
          <div v-else>
            {{ util.addComma(scope.row.chip_price) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="" width="50">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.id === editingId"
            size="mini"
            icon="el-icon-check"
            type="primary"
            circle
            :disabled="!has_grant_write"
            @click="handleClickSave(scope.row)"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="created_user_name"
        :label="$t('lang.created_user_name')"
        :width="$width.username"
      />
      <el-table-column
        prop="modified_user_name"
        :label="$t('lang.modified_user_name')"
        :width="$width.username"
      />
      <el-table-column
        prop="created_at"
        :label="$t('lang.created_at')"
        :width="$width.date"
        :formatter="util.dateFormat"
      />
      <el-table-column
        prop="modified_at"
        :label="$t('lang.modified_at')"
        :width="$width.date"
        :formatter="util.dateFormat"
      />
      <div slot="buttons">
        <el-upload
          class="inline"
          action="#"
          :show-file-list="false"
          :auto-upload="false"
          :on-change="handleOnChange"
        >
          <el-button type="primary">단가 엑셀 등록</el-button>
        </el-upload>
      </div>
    </ATable>
    <el-dialog
      title="일부 항목 등록 실패"
      width="600px"
      :visible.sync="excel_dialog_visible"
      destroyOnClose
    >
      <ATable
        class="no-pointer"
        :data="items_fail"
        border
        hide-top-panel
        hide-button-insert
        hide-pagination
      >
        <el-table-column prop="name" label="품목명" />
        <el-table-column prop="color" label="색상" />
        <el-table-column
          prop="thick"
          label="두께"
          width="50"
          class-name="cell-number"
        />
        <el-table-column label="실패 이유" :formatter="resolveReason" />
      </ATable>
      <el-button type="primary" @click="handleClickRegister"
        >저장<AHelper type="warning"
          >저장 시 실패한 항목 외 항목을 저장합니다.</AHelper
        ></el-button
      >
      <el-button @click="handleClickClose" class="ml-default">취소</el-button>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { enter_tab } from "@/common/mixins/enter_tab";
import XLSX from "xlsx";

export default {
  name: "GlassCost",
  mixins: [enter_tab],
  data() {
    return {
      title: this.$t("title.glass_cost"),
      placeholder: "코드, 품목, 색상",
      search_field: ["product_code", "product_name", "glass_color_name"],
      editingId: 0,
      loading: false,
      search_glass_thickness_name: 0,
      excel_dialog_visible: false,
      items_fail: [],
      excelProductInfo: [
        "코드",
        "품목",
        "색상",
        "두께",
        "평단가",
        "면취비",
        "따내기",
      ],
      saveItems: [],
    };
  },
  props: {
    has_grant_write: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters([
      "table_customer_glass_level",
      "table_product",
      "table_product_glass_price",
      "table_glass_color",
      "table_glass_thickness",
    ]),
    items: function() {
      let items = [];
      this.table_product_glass_price.forEach((e) => {
        let product = this.table_product.find((p) => p.id === e.product_id);
        let color = this.table_glass_color.find(
          (g) => g.id === e.glass_color_id
        );
        let thickness = this.table_glass_thickness.find(
          (t) => t.id === e.glass_thickness_id
        );
        if (!product || !color || !thickness) {
          return true;
        }
        let item = Object.assign({}, e);
        item.product_code = product.code;
        item.product_name = product.name;
        item.glass_color_name = color.name;
        item.glass_thickness_name = thickness.name;
        item.custom = [];
        this.table_customer_glass_level.forEach((cl) => {
          let pgcp = item.customers.find(
            (c) => c.customer_glass_level_id === cl.id
          );
          if (pgcp) {
            item.custom[cl.id] = Object.assign({}, pgcp);
          } else {
            item.custom[cl.id] = {
              customer_glass_level_id: cl.id,
              ratio_flag: "N",
              price: 0,
            };
          }
          item["price_" + cl.id] = item.custom[cl.id].price;
        });
        items.push(item);
      });
      return items.sort(this.sortItem);
    },
    filteredItem() {
      let filteredItems = [];
      if (this.search_glass_thickness_name === 0) {
        return this.items;
      }
      filteredItems = this.items.filter(
        (item) => item.glass_thickness_name === this.search_glass_thickness_name
      );
      return filteredItems ? filteredItems : this.items;
    },
  },
  methods: {
    doRegister(item) {
      if (!this.editingId) {
        return;
      }
      let pgp = Object.assign({}, item);
      pgp.customers = [];
      for (let key in pgp.custom) {
        if (pgp.custom[key].price) {
          pgp.customers.push(pgp.custom[key]);
        }
      }
      // insert & update
      this.api.saveProductGlassPrice(pgp).then((res) => {
        this.handleResult(res);
      });
    },
    sortItem(a, b) {
      if (a.product_name > b.product_name) {
        return 1;
      } else if (a.product_name < b.product_name) {
        return -1;
      } else if (a.glass_color_name > b.glass_color_name) {
        return 1;
      } else if (a.glass_color_name < b.glass_color_name) {
        return -1;
      } else {
        let ta = Number.parseFloat(a.glass_thickness_name);
        let tb = Number.parseFloat(b.glass_thickness_name);
        return ta - tb;
      }
    },
    handleIndex(index) {
      return this.$refs.table.indexResolver(index);
    },
    handleCellClick(item, column) {
      if (!column.property) {
        return;
      }
      if (this.editingId === item.id) {
        return;
      }
      this.doRegister(item);
      this.editingId = item.id;
    },
    /** checkbox 가 v-model이 적용이 안 돼 이벤트로 처리 */
    // handleChangeRatioFlag(item, level, checked) {
    //   item.custom[level].ratio_flag = checked;
    // },
    handleClickSave(item) {
      this.doRegister(item);
      this.editingId = 0;
    },
    handleResult(res) {
      if (res.error !== this.system.noError) {
        this.util.notify_response_error(this, this.title, res);
        return;
      }
    },
    handleOnChange(event) {
      const file = event.raw;
      const reader = new FileReader();
      reader.onload = this.loadExcel;
      reader.readAsArrayBuffer(file);
    },
    loadExcel(e) {
      let tmpResult = {};
      let data = e.target.result;
      data = new Uint8Array(data);
      let excelFile;
      try {
        excelFile = XLSX.read(data, {
          type: "array",
          cellDates: true,
          cellNF: false,
          cellText: false,
        });
      } catch (ex) {
        this.util.notify_error(this, this.title, "엑셀 파일이 아닙니다.");
        return;
      }
      excelFile.SheetNames.forEach((sheetName) => {
        const costItems = XLSX.utils.sheet_to_json(
          excelFile.Sheets[sheetName],
          { header: 1 }, // 모든 헤더 정보를 array로 가져옴
          { raw: true, dateNF: "YYYY-MM-DD" }
        );
        if (costItems.length) tmpResult[sheetName] = costItems;
      });

      this.parseExcel(tmpResult["유리단가"]);
    },
    parseExcel(result) {
      const excelItems = [];
      // 헤더 정보 분리
      if (!result) {
        this.loading = false;
        this.util.notify_error(
          this,
          this.title,
          "양식과 맞지 않는 파일을 선택하였습니다."
        );
        return;
      }
      const excelHeaderInfo = result.splice(0, 1)[0];
      // table_product의 name에 해당하는 '품목명' 컬럼 존재 여부 확인
      // 존재하지 않으면 excel import 종료
      // 품목명이 없으면 product 정보를 찾아서 비교 할 수 없어 진행 불가
      const headerNameIndex = excelHeaderInfo.findIndex(
        (f) => f === this.excelProductInfo[1]
      );
      if (headerNameIndex < 0) {
        this.loading = false;
        this.util.notify_error(
          this,
          this.title,
          "엑셀 파일에 [" + this.excelProductInfo[1] + "] 정보가 없습니다."
        );
        return;
      }

      const headerColorIndex = excelHeaderInfo.findIndex(
        (f) => f === this.excelProductInfo[2]
      );
      if (headerColorIndex < 0) {
        this.loading = false;
        this.util.notify_error(
          this,
          this.title,
          "엑셀 파일에 [" + this.excelProductInfo[2] + "] 정보가 없습니다."
        );
        return;
      }

      const headerThickIndex = excelHeaderInfo.findIndex(
        (f) => f === this.excelProductInfo[3]
      );
      if (headerThickIndex < 0) {
        this.loading = false;
        this.util.notify_error(
          this,
          this.title,
          "엑셀 파일에 [" + this.excelProductInfo[3] + "] 정보가 없습니다."
        );
        return;
      }

      // table_product_price의 price에 해당하는 '평단가' 컬럼 정보의 index
      const headerPriceIndex = [];
      for (var nIdx = 4; nIdx < 7; nIdx++) {
        headerPriceIndex.push(
          excelHeaderInfo.findIndex((f) => f === this.excelProductInfo[nIdx])
        );
      }
      const items_fail = [];
      result.forEach((item) => {
        let data = {
          name: item[headerNameIndex],
          color: item[headerColorIndex],
          thick: item[headerThickIndex],
        };
        for (var nIdx = 4; nIdx < 7; nIdx++) {
          // '평단가' 와 명칭이 일치하는 컬럼 정보가 존재하면 정보를 가져옴
          if (headerPriceIndex[nIdx - 4] > -1) {
            switch (nIdx) {
              case 4:
                data.price = Number.parseInt(
                  this.util.removeComma(item[headerPriceIndex[nIdx - 4]])
                );
                break;
              case 5:
                data.chamfer_price = Number.parseInt(
                  this.util.removeComma(item[headerPriceIndex[nIdx - 4]])
                );
                break;
              case 6:
                data.chip_price = Number.parseInt(
                  this.util.removeComma(item[headerPriceIndex[nIdx - 4]])
                );
                break;
            }
          }
        }

        // 현재 설정된 기계등급 정보를 기반으로 excel header 정보를 비교하여
        // 일치하는 컬럼의 정보만 가져옴
        this.table_customer_glass_level.forEach((cl) => {
          const headerCustomerLevelIndex = excelHeaderInfo.findIndex(
            (f) => f === cl.code
          );
          if (headerCustomerLevelIndex > -1) {
            data[cl.id] = Number.parseInt(
              this.util.removeComma(item[headerCustomerLevelIndex])
            );
          }
        });

        let product = this.table_product.find((f) => f.name === data.name);
        let color = this.table_glass_color.find((g) => g.name === data.color);
        let thickness = this.table_glass_thickness.find(
          (t) => t.name === data.thick
        );
        if (product && color && thickness) {
          let product_price = this.table_product_glass_price.find(
            (f) =>
              f.product_id === product.id &&
              f.glass_color_id == color.id &&
              f.glass_thickness_id == thickness.id
          );
          if (product_price) {
            data.product_price = JSON.parse(JSON.stringify(product_price));
            excelItems.push(data);
          } else {
            items_fail.push(data);
          }
        } else {
          data.product_price = null;
          items_fail.push(data);
        }
      });
      this.items_fail = items_fail;
      this.doRegisterByExcel(excelItems);
    },
    parseCustomerPrice(item) {
      const newCustomers = [];
      this.table_customer_glass_level.forEach((cl) => {
        const excelValue = item[cl.id];
        const customerLevelItem = item.product_price.customers.find(
          (f) => f.customer_level_id === cl.id
        );
        if (customerLevelItem) {
          customerLevelItem.price = excelValue;
          newCustomers.push(customerLevelItem);
        } else if (excelValue) {
          const newItem = {
            id: 0,
            customer_glass_level_id: cl.id,
            ratio_flag: "N",
            price: excelValue,
          };
          newCustomers.push(newItem);
        }
      });
      return newCustomers;
    },
    doRegisterByExcel(excelItems) {
      const saveItems = [];
      excelItems.forEach((item) => {
        if (item.product_price.price !== item.price) {
          item.product_price.price = item.price;
        }
        if (item.product_price.chamfer_price !== item.chamfer_price) {
          item.product_price.chamfer_price = item.chamfer_price;
        }
        if (item.product_price.chip_price !== item.chip_price) {
          item.product_price.chip_price = item.chip_price;
        }
        item.product_price.customers = this.parseCustomerPrice(item);
        saveItems.push(item.product_price);
      });
      this.saveItems = saveItems;
      if (this.items_fail.length) {
        this.excel_dialog_visible = true;
      } else {
        this.doRegisterByExcelConfirm();
      }
    },
    handleClickRegister() {
      this.doRegisterByExcelConfirm();
    },
    handleClickClose() {
      this.excel_dialog_visible = false;
      this.items_fail = [];
    },
    doRegisterByExcelConfirm() {
      this.loading = true;
      this.api.saveProductGlassPriceByExcel(this.saveItems).then((res) => {
        this.handleClickClose();
        this.saveItems = [];
        this.handleResult(res);
        this.loading = false;
      });
    },
    parseData(header) {
      const excelData = [];
      this.items.forEach((item) => {
        /**
         * 기계등급관리 메뉴에서 설정되는 정보에 따라 table_customer_glass_level 값이 변경됨
         * excel 에 저장하기 위해서는 header 순서에 따라 적용된 값의 순서도 같아야 함
         * 그래서 적용될 값의 순서를 정렬하기 위해 index 값을 숫자로 정의함
         * table_customer_glass_level 의 id 값에 100 을 더해 앞에
         * product code(코드), name(품목명), color(색상), thick(두께), price(기본가) 정보가 먼저 오도록 정의함
         */

        const rowData = {
          1: item.product_code, // product code
          2: item.product_name, // product name
          3: item.glass_color_name, // glass color name
          4: item.glass_thickness_name, // glass thcik name
          5: item.price ? this.util.addComma(item.price) : 0, // product price
          6: item.chamfer_price ? this.util.addComma(item.chamfer_price) : 0, // chamfer price
          7: item.chip_price ? this.util.addComma(item.chip_price) : 0, // chip price
        };
        this.table_customer_glass_level.forEach((cl) => {
          if (header.find((f) => f === cl.code)) {
            const price = item.custom[cl.id].price;
            rowData[cl.id + 100] = this.util.addComma(price);
          }
        });
        excelData.push(rowData);
      });
      return excelData;
    },
    handleClickExportExcel() {
      const workBook = XLSX.utils.book_new();
      const header = [this.makeExcelHeaderInfo()];
      const workSheet = XLSX.utils.json_to_sheet(this.parseData(header[0]), {
        origin: "A1",
      });
      XLSX.utils.sheet_add_aoa(workSheet, header);
      XLSX.utils.book_append_sheet(workBook, workSheet, "유리단가");
      XLSX.writeFile(workBook, "유리단가관리.xlsx");
    },
    makeExcelHeaderInfo() {
      const excelHeaderInfo = JSON.parse(JSON.stringify(this.excelProductInfo));
      this.table_customer_glass_level.forEach((item) => {
        excelHeaderInfo.push(item.code);
      });
      return excelHeaderInfo;
    },
    resolveReason(item) {
      if (!item.product_price) {
        return "유리 구성에 없는 항목";
      } else {
        return "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.price-ratio {
  flex: 0 0 20px;
  padding: 0 3px;
}
.font-prop {
  font-weight: bold;
  font-size: 12px;
  margin-top: 2px;
  margin-right: 10px;
  text-align: right;
}
.error-row {
  color: red;
}
</style>
